import { render, staticRenderFns } from "./LandingInputFooter.vue?vue&type=template&id=3eb2c0d0&scoped=true&"
import script from "./LandingInputFooter.vue?vue&type=script&lang=js&"
export * from "./LandingInputFooter.vue?vue&type=script&lang=js&"
import style0 from "./LandingInputFooter.vue?vue&type=style&index=0&id=3eb2c0d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb2c0d0",
  null
  
)

export default component.exports